export function setTarifas(state, tarifas) {
    state.tarifas = tarifas;
    let index = state.tarifas.findIndex(
        (e) => e.nombre === "Alquiler de 1 a 7 días"
    );
    if (index != -1) {
        state.tarifaMenosDe7 =  state.tarifas[index].precio;   
    }
    
    index = state.tarifas.findIndex(
        (e) => e.nombre === "Alquiler más de 7 días"
    );
    if (index != -1) {
        state.tarifaMasDe7 =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Tarifa menos de 7 sin IVA"
    );
    if (index != -1) {
        state.tarifaMenosDe7SinIVA =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Tarifa más de 7 sin IVA"
    );
    if (index != -1) {
        state.tarifaMasDe7SinIVA =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Tarifa menos de 7 Agencia"
    );
    if (index != -1) {
        state.tarifaMenosDe7Agencia =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Tarifa más de 7 Agencia"
    );
    if (index != -1) {
        state.tarifaMasDe7Agencia =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Tarifa menos de 7 sin IVA Agencia"
    );
    if (index != -1) {
        state.tarifaMenosDe7SinIVAAgencia =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Tarifa más de 7 sin IVA Agencia"
    );
    if (index != -1) {
        state.tarifaMasDe7SinIVAAgencia =  state.tarifas[index].precio;   
    }




    index = state.tarifas.findIndex(
        (e) => e.nombre === "Muscular de 1 a 7 días"
    );
    if (index != -1) {
        state.muscularMenosDe7 =  state.tarifas[index].precio;   
    }
    
    index = state.tarifas.findIndex(
        (e) => e.nombre === "Muscular más de 7 días"
    );
    if (index != -1) {
        state.muscularMasDe7 =  state.tarifas[index].precio;   
    }
    index = state.tarifas.findIndex(
        (e) => e.nombre === "Muscular menos de 7 sin IVA"
    );
    if (index != -1) {
        state.muscularMenosDe7SinIVA =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Muscular más de 7 sin IVA"
    );
    if (index != -1) {
        state.muscularMasDe7SinIVA =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Muscular menos de 7 Agencia"
    );
    if (index != -1) {
        state.muscularMenosDe7Agencia =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Muscular más de 7 Agencia"
    );
    if (index != -1) {
        state.muscularMasDe7Agencia =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Muscular menos de 7 sin IVA Agencia"
    );
    if (index != -1) {
        state.muscularMenosDe7SinIVAAgencia =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Muscular más de 7 sin IVA Agencia"
    );
    if (index != -1) {
        state.muscularMasDe7SinIVAAgencia =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Transporte SEUR"
    );
    if (index != -1) {
        state.tarifaSEUR =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Transporte Km"
    );
    if (index != -1) {
        state.tarifaKm =  state.tarifas[index].precio;   
    }

    index = state.tarifas.findIndex(
        (e) => e.nombre === "Fianza"
    );
    if (index != -1) {
        state.tarifaFianza =  state.tarifas[index].precio;   
    }
}

export function setTarifaSelec(state, tarifa) {
    state.tarifaSelec = tarifa;
}

export function setTarifaKm(state, tarifaKm) {
    state.tarifaKm = tarifaKm;
}




export function actListTarifas(state, tarifa) {
    if (tarifa !== null) {
        const index = state.tarifas.findIndex(r => r.id === tarifa.id)
        if (index != -1) {
            state.tarifas[index].nombre = tarifa.nombre;  
            state.tarifas[index].precio = tarifa.precio;  
            state.tarifas[index].descripcion = tarifa.descripcion;  
        }
    }
  
}

export function actDeleteListTarifas(state, id) {
    if (id != null) {
        const index = state.tarifas.findIndex(r => r.id === id)
        if (index != -1) {
            state.tarifas.splice(index, 1)
        }
    }
}


